<template>
  <v-dialog width="500" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon small text v-on="on" title="Lista de documentos">
        <v-icon small>mdi-file-multiple</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <lista-documentos
        :url-base="urlBase"
        :id-proprietario="IdProprietario"
        v-model="docs"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ListaDocumentos from "./ListaDocumentos";
export default {
  components: { ListaDocumentos },
  props: ["title", "urlBase", "IdProprietario"],
  data() {
    return {
      dialog: false,
      docs: [],
    };
  },
  watch: {
    dialog(open) {
      if (open) {
        this.$emit("open");
      }
    },
  },
};
</script>
